import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';

import { calendarApi, useCalendar } from '../../api';
import { ReDateEventsDialog } from '../dialogs/ReDateEventsDialog';
import { useDealActivityMutations } from '../../../api';

interface Props {
  selectedIds: string[];
  onClose: VoidFunction;
}

export const BulkActions = ({ selectedIds, onClose }: Props) => {
  const { isCompleting, isMovingToTomorrow, handleCompleteEvent, handleMoveToTomorrowEvent } = useCalendar();
  const { handleDeleteMultipleDealActivities, isDealActivityDeletingMultiple } = useDealActivityMutations();

  const [isReDateDialogOpen, setIsReDateDialogOpen] = useState(false);

  return (
    <Stack direction="row" gap="1rem">
      <Button size="small" variant="text" onClick={() => setIsReDateDialogOpen(true)}>
        Redate
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isMovingToTomorrow}
        onClick={async () => {
          await handleMoveToTomorrowEvent(selectedIds, api => ({
            awaitRefetchQueries: true,
            refetchQueries: [api.events.queries.listing],
          }));

          onClose();
        }}
      >
        Move to Tomorrow
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isCompleting}
        onClick={async () => {
          await handleCompleteEvent(selectedIds, api => ({
            awaitRefetchQueries: true,
            refetchQueries: [api.events.queries.listing],
          }));

          onClose();
        }}
      >
        Complete
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isDealActivityDeletingMultiple}
        onClick={async () => {
          await handleDeleteMultipleDealActivities({ ids: selectedIds }, () => ({
            awaitRefetchQueries: true,
            refetchQueries: [calendarApi.events.queries.listing],
          }));

          onClose();
        }}
      >
        Delete
      </Button>

      <ReDateEventsDialog
        ids={selectedIds}
        isOpen={isReDateDialogOpen}
        onClose={() => setIsReDateDialogOpen(false)}
        onSuccess={() => {
          setIsReDateDialogOpen(false);
          onClose();
        }}
      />
    </Stack>
  );
};
